export enum RefundTimings {
  instant = "instant",
  inspection = "inspection",
}
